import { Component, inject, input, numberAttribute } from '@angular/core';
import { DmBadge, DmButton, DmIcon } from '@digitale-menschen/component-library-angular';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'lp-error-component',
  imports: [DmBadge, DmButton, DmIcon],
  templateUrl: './error-message-plain.component.html',
  styleUrl: './error-message-plain.component.scss',
  host: {
    class:
      'dm-flex dm-justify-center dm-relative dm-overflow-hidden dm-padding-horizontal-16 desktop:dm-padding-horizontal-32 dm-padding-vertical-48 dm-items-center desktop:dm-padding-vertical-0',
  },
})
export class ErrorMessagePlainComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  /**
   * Bound from the `errorNumber` query parameter by `withComponentInputBinding()`, which hands it
   * over as a raw string. Falls back to 404 for a missing or non-numeric value.
   */
  public readonly errorNumber = input(404, { transform: (value: unknown) => numberAttribute(value, 404) });

  protected async goHome(): Promise<void> {
    // todo: integrate the language: '/' + LOCALE_ID, from Angular (import { LOCALE_ID } from '@angular/core';)
    await this.router.navigateByUrl('/');
  }

  protected goBack(): void {
    this.location.back();
  }
}
